import { render, staticRenderFns } from "./medicine_refrigerator_card.vue?vue&type=template&id=c10880dc&scoped=true&"
import script from "./medicine_refrigerator_card.vue?vue&type=script&lang=js&"
export * from "./medicine_refrigerator_card.vue?vue&type=script&lang=js&"
import style0 from "./medicine_refrigerator_card.vue?vue&type=style&index=0&id=c10880dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10880dc",
  null
  
)

export default component.exports